// extracted by mini-css-extract-plugin
module.exports = {"container":"appLoader_container__2M8G0","logo":"appLoader_logo__Rf0jZ","animation":"appLoader_animation__qnUs9","gradient":"appLoader_gradient__1CmOY"};